import React from "react";
import { useSelector } from "react-redux";
import Divider from "@material-ui/core/Divider";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";

const B2BCartItem = ({
  product,
  cart,
  showPrice,
  handleRemoveItemFromCart,
}) => {
  const language = useSelector((state) => state.store.language);
  const settings = useSelector((state) => state.store.store.settings);
  const themeColorSetting = useSelector(
    (state) => state.store.store.settings.dark
  );
  const themeColor = themeColorSetting ? themeColorSetting : "#0099cc";
  const currency =
    language === "english"
      ? settings?.currency_english
      : settings?.currency_local;
  const currencyIcon = getCurrencyIcon(settings)
  return (
    <>
      <div
        style={{
          display: "flex",
          padding: 10,
          flexDirection: language === "english" ? "row" : "row-reverse",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <img
            alt={product.name}
            style={{
              borderRadius: 4,
              width: 50,
              height: 50,
            }}
            src={product.photo_thumb || product.photo}
          />
          <span
            onClick={() => handleRemoveItemFromCart(product)}
            style={{
              color: "red",
              fontWeight: "bold",
              fontSize: "0.9rem",
              marginTop: 5,
            }}
          >
            {language === "english" ? "remove" : "إزالة"}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: language === "english" ? "row" : "row-reverse",
            justifyContent: "space-between",
            flex: 1,
          }}
        >
          <span
            style={{
              fontWeight: "bold",
              textAlign: language === "english" ? "left" : "right",
              marginLeft: language === "english" ? 10 : 5,
              marginRight: language === "english" ? 5 : 10,
            }}
          >
            {language === "english" ? product.name : product.ar_name}
          </span>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: language === "english" ? "flex-end" : "flex-start",
            }}
          >
            {showPrice && (
              <span
                className={currencyIcon}
                style={{
                  color: themeColor,
                  fontWeight: "bold",
                  textAlign: "right",
                  whiteSpace: "nowrap",
                }}
              >
                {(product.price * cart[product.id]).toFixed(
                  settings.currency_decimals
                )}{" "}
                {currency}
              </span>
            )}
            <span style={{ color: themeColor, fontWeight: "bold" }}>
              x{cart[product.id]}
            </span>
          </div>
        </div>
      </div>
      <Divider />
    </>
  );
};

export default B2BCartItem;
